// @ts-nocheck
import React from "react";
import { FiTrash2 } from "react-icons/fi";
import { ReactComponent as HomeSmile } from "../../assets/icons/home-smile.svg";
import { useNavigate } from "react-router-dom";

// Columns that fold away on a phone, so the name and its actions always stay on one row
const DETAIL_COLUMNS = [
  { key: "parameter", label: "Parameter" },
  { key: "objective", label: "Objective" },
  { key: "seasonality", label: "Seasonality" },
  { key: "optimizationHorizon", label: "Optimization Horizon" },
];

const HEAD_CLASS =
  "whitespace-nowrap border-b border-eai-border bg-eai-surface-hover px-4 py-2.5 text-left font-outfit text-eai-meta font-medium uppercase text-eai-ink-subtle";

// "peak_demand" -> "Peak Demand"
const formatOutPut = (input) =>
  (input || "")
    .split("_")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");

export const CustomModelRow = ({ record, onRecordDelete }) => {
  const navigate = useNavigate();

  const openRecord = () => navigate(`/home/dataupload/${record.id}`);

  return (
    <tr
      onClick={openRecord}
      className="cursor-pointer border-b border-eai-border transition-colors hover:bg-eai-surface-hover"
    >
      <td className="px-4 py-3">
        <div className="flex items-center gap-3">
          <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-eai-surface-hover shadow-eai-subtle">
            <HomeSmile className="h-5 w-5" />
          </div>
          <span className="eai-card-title">{record.name}</span>
        </div>
      </td>

      {DETAIL_COLUMNS.map(({ key }) => (
        <td
          key={key}
          className="hidden whitespace-nowrap px-4 py-3 font-inter text-eai-body-sm text-eai-ink-subtle md:table-cell"
        >
          {formatOutPut(record[key])}
        </td>
      ))}

      <td className="px-4 py-3">
        {/* Destructive first, then the Edit pill — the app's standard action row */}
        <div className="flex items-center justify-end gap-2">
          <button
            type="button"
            aria-label="Delete model"
            title="Delete model"
            onClick={(e) => {
              e.stopPropagation();
              onRecordDelete(record.id);
            }}
            className="eai-btn-icon eai-btn-icon-danger"
          >
            <FiTrash2 size={12} />
          </button>
          <button
            type="button"
            onClick={(e) => {
              e.stopPropagation();
              openRecord();
            }}
            className="eai-btn-outline-xs"
          >
            Edit
          </button>
        </div>
      </td>
    </tr>
  );
};

export const CustomModelTable = ({ records, onDeleteRecord }) => {
  return (
    <table className="w-full border-separate border-spacing-0 text-left">
      <thead>
        <tr>
          <th className={HEAD_CLASS}>Name</th>
          {DETAIL_COLUMNS.map(({ key, label }) => (
            <th key={key} className={`${HEAD_CLASS} hidden md:table-cell`}>
              {label}
            </th>
          ))}
          <th className={`${HEAD_CLASS} text-right`}>Actions</th>
        </tr>
      </thead>
      <tbody>
        {records.map((record) => (
          <CustomModelRow
            key={record.id}
            record={record}
            onRecordDelete={(id) => onDeleteRecord(id)}
          />
        ))}
      </tbody>
    </table>
  );
};
